import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    projectType: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // EmailJS configuration - Your actual values
    const serviceId = 'service_3f8b781';
    const templateId = 'template_paxns5b';
    const publicKey = 'wtbiVbDXZvVWC9o4s';
    
    // Send email using EmailJS
    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      phone: formData.phone,
      project_type: formData.projectType,
      message: formData.message,
      to_email: 'info.njmcs@gmail.com'
    };

    emailjs.send(serviceId, templateId, templateParams, publicKey)
      .then((response) => {
        console.log('Email sent successfully!', response.status, response.text);
        alert('Thank you for your message! We will get back to you soon.');
      })
      .catch((error) => {
        console.error('Error sending email:', error);
        alert('Sorry, there was an error sending your message. Please try again or contact us directly.');
      });
    
    // Clear form after submission
    setFormData({
      name: '',
      email: '',
      phone: '',
      projectType: '',
      message: ''
    });
  };

  return (
    <div className="contact">
      <div className="contact-hero">
        <div className="container">
          <h1>Get In Touch</h1>
          <p>Let's build your vision together</p>
        </div>
      </div>

      <div className="contact-content">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Form */}
            <div className="contact-form-section">
              <h2>Send Us a Message</h2>
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="projectType">Project Type</label>
                  <select
                    id="projectType"
                    name="projectType"
                    value={formData.projectType}
                    onChange={handleChange}
                  >
                    <option value="">Select Project Type</option>
                    <option value="home-renovation">Home Renovation</option>
                    <option value="bathroom-remodeling">Bathroom Remodeling</option>
                    <option value="roofing">Roofing</option>
                    <option value="flooring">Flooring</option>
                    <option value="sheetrock">Sheetrock</option>
                    <option value="paint">Paint</option>
                    <option value="siding">Siding</option>
                    <option value="carpentry">Carpentry</option>
                    <option value="masonry">Masonry</option>
                    <option value="furniture-assembly">Furniture Assembly</option>
                    <option value="junk-removal">Junk Removal</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Project Details *</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Please describe your project requirements, timeline, and any specific needs..."
                    required
                  ></textarea>
                </div>

                <button type="submit" className="submit-button">
                  Send Message
                </button>
              </form>
            </div>

            {/* Contact Information */}
            <div className="contact-info-section">
              <h2>Contact Information</h2>
              
              <div className="contact-info">
                <div className="info-item">
                  <div className="info-icon">📍</div>
                  <div className="info-content">
                    <h3>Location</h3>
                    <p>
                      Pennsylvania, New York, New Jersey
                    </p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">📞</div>
                  <div className="info-content">
                    <h3>Phone</h3>
                    <p>
                      <a href="tel:+19082473266">(908) 247-3266</a><br />
                      <a href="tel:+16465756660">(646) 575-6660</a>
                    </p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">✉️</div>
                  <div className="info-content">
                    <h3>Email</h3>
                    <p>
                      <a href="mailto:info.njmcs@gmail.com">info.njmcs@gmail.com</a>
                    </p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">🕒</div>
                  <div className="info-content">
                    <h3>Business Hours</h3>
                    <p>
                      Monday - Friday: 7:00 AM - 6:00 PM<br />
                      Saturday: 8:00 AM - 4:00 PM<br />
                      Sunday: Closed
                    </p>
                  </div>
                </div>
              </div>

              {/* Why Choose Us */}
              <div className="contact-why-choose">
                <h3>Why Choose NJ-MCS?</h3>
                <ul>
                  <li>Free consultation and estimates</li>
                  <li>Licensed, bonded, and insured</li>
                  <li>10+ years of experience</li>
                  <li>Quality workmanship guarantee</li>
                  <li>On-time project delivery</li>
                  <li>Competitive pricing</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Map Section */}
          <div className="map-section">
            <h2>Find Us</h2>
            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3024.4!2d-74.0!3d40.7!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDQyJzAwLjAiTiA3NMKwMDAnMDAuMCJX!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="NJ-MCS Service Area Map"
              ></iframe>
              <div className="map-info">
                <h3>Our Service Area</h3>
                <p>We proudly serve Pennsylvania, New York, and New Jersey including:</p>
                <ul>
                  <li>Pennsylvania</li>
                  <li>New York</li>
                  <li>New Jersey</li>
                  <li>Surrounding areas</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
